import React from 'react';
import { useInView } from '@/hooks/useInView';

export const WhatIOffer = () => {
  const [ref, isInView] = useInView();

  return (
    <section data-testid="what-i-offer-section" className="py-16 lg:py-24 bg-secondary" ref={ref}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <p className="text-primary font-semibold text-sm uppercase tracking-widest mb-3 text-center">
            What I Offer
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-8 text-center leading-snug">
            Partner With a Google Ads Expert Who Knows How to Scale
          </h2>
          <div className="space-y-5 text-muted-foreground leading-relaxed text-center">
            <p>
              My fully managed Google Ads service is designed for businesses that want real, measurable
              growth, whether you're launching your first campaign or trying to outperform past results.
              I take care of everything from initial setup to continuous optimization, so you can focus
              on running your business while your ads work in the background.
            </p>
            <p>
              With experience across a wide range of industries, I know how to turn ad spend into outcomes
              that matter: qualified leads, consistent sales, and a stronger return on every dollar you invest.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
